import { KPICard } from "./KPICard";
import { ConsumptionTable, CubeBasicFilters } from "../schemas/kpi.types";
import React, { useEffect, useState } from "react";
import { kpiService } from "./kpi-service";
import { formatCurrency, formatPercent } from "../schemas/dashboard.utils";

export const KPICarouselCards: React.FC<{
    cubeFilters: CubeBasicFilters;
}> = ({ cubeFilters }) => {
    const [summary, setSummary] = useState<ConsumptionTable[]>([]);
    const [loading, setLoading] = useState(false);
    const { idClient, idQuotes, policy } = cubeFilters;

    const quotesExist = idQuotes?.length !== 1;

    useEffect(() => {
        const loadData = async () => {
            if (!idClient) return;
            try {
                setLoading(true);
                const data = await kpiService.fetchAccident(cubeFilters, quotesExist);
                setSummary(data);
            } catch (error) {
                console.error("Error al cargar tabla:", error);
            } finally {
                setLoading(false);
            }
        };

        void loadData();
    }, [idClient, idQuotes, policy]);

    const premiumBilled = summary.reduce((accum, cube) => accum + (cube["premiumsBilled"] || 0), 0);
    const premiumIncurred = summary.reduce((accum, cube) => accum + (cube["premiumsIncurred"] || 0), 0);
    const accidentRate = premiumBilled > 0 ? (premiumIncurred / premiumBilled) * 100 : 0;

    return (
        <div className={"row"}>
            <div className={"col-lg-4 col-md-6 col-12 mb-2 mb-lg-0"}>
                <KPICard
                    title="Primas facturadas"
                    value={premiumBilled ? formatCurrency(premiumBilled) : "$ 0,00"}
                    loading={loading}
                />
            </div>
            <div className={"col-lg-4 col-md-6 col-12 mb-2 mb-lg-0"}>
                <KPICard
                    title="Reclamos incurridos"
                    value={premiumIncurred ? formatCurrency(premiumIncurred) : "$ 0,00"}
                    loading={loading}
                />
            </div>
            <div className={"col-lg-4 col-md-6 col-12 mb-2 mb-lg-0"}>
                <KPICard
                    title="Siniestralidad"
                    value={accidentRate ? formatPercent(accidentRate) : "0%"}
                    loading={loading}
                />
            </div>
        </div>
    );
};
